// Which portal the SPA is running inside. The portal loaders (deploy/<portal>/index.html)
// full-screen-iframe the app with a ?portal=<name> marker; a top-level (non-iframed)
// load is a "direct" login. Captured ONCE at module load, before any SPA routing can
// strip the query string.
export type Portal = 'itch' | 'crazygames' | 'direct';

function detectPortal(): Portal {
  try {
    const p = new URLSearchParams(window.location.search).get('portal');
    if (p === 'itch' || p === 'crazygames' || p === 'direct') return p;
    // No explicit marker: a cross-site iframe means a portal (assume itch, the
    // original portal whose loader predates the marker); top-level = direct.
    return window.self !== window.top ? 'itch' : 'direct';
  } catch {
    // Accessing window.top across origins can throw — that only happens when framed.
    return 'itch';
  }
}

export const PORTAL: Portal = detectPortal();
export const isCrazyGames = PORTAL === 'crazygames';
